import type { CommentTagNotificationEntity } from '@/api/v4/notifications.api';
import { fetchCompany } from '@/api/v4/organization.api';
import { fetchProject } from '@/api/v4/projects.api';
import { QueryKey } from '@/config/query-client';
import { getTimeInMs } from '@/helpers/get-time-in-ms';
import { useQuery } from '@tanstack/react-query';

export const useCommentTagNotificationEntityName = ({
  entityType,
  entityId,
}: {
  entityType: CommentTagNotificationEntity;
  entityId: string;
}) => {
  const getEntityData = async () => {
    if (entityType === 'project') {
      return fetchProject(entityId);
    }

    if (entityType === 'company') {
      return fetchCompany(entityId);
    }

    return;
  };

  const { data } = useQuery({
    queryKey: [QueryKey.NotificationCommentTagEntity, entityId],
    queryFn: getEntityData,
    retry: false,
    staleTime: getTimeInMs(5, 'minute'),
  });

  const name =
    data?.name && typeof data?.name === 'object' && 'value' in data.name
      ? data?.name.value
      : (data?.name as string);

  return name;
};
